import { styled } from "@vitality-ds/system";
import { components } from "react-select";
import CustomSelectInputStyles from "./styles/CustomSelectInput.styles";

// eslint-disable-next-line import/prefer-default-export
export var CustomSelectInput = styled(components.Input, CustomSelectInputStyles);